import React from 'react'
import profileImage from "../../assets/imgs/dummy-img.png"
import "../passenger/passenger.css"
import { Avatar } from 'primereact/avatar'
import { Rating } from 'primereact/rating'
import { Button } from 'primereact/button'
const DetailRideCard = ({ btnLabel }) => {
    return (
        <div className='surface-card p-4 md:m-2'>
            <div className='flex align-items-center justify-content-between '>

                <div className="flex align-items-center cursor-pointer">
                    <Avatar className="profile-image border-circle cursor-pointer mr-3" image={profileImage} size="xlarge" shape="circle" />
                    <div>
                        <p className="mb-1 text-lg font-semibold">M.Sohaib</p>
                        <Rating value={3} readOnly cancel={false} />
                    </div>
                </div>
                <div className='cursor-pointer'>
                    View owner
                </div>
            </div>
            <hr />
            <div className='flex align-items-center justify-content-between flex-wrap ml-2'>
                <h6 className='my-1'>Date & Time</h6>
                <div className='flex align-items-center'>
                    <span className='font-semibold'>17-10-2024</span>
                    <span className='mx-2 font-semibold'>03:19 PM -</span>
                    <span className='font-semibold'>03:50 PM</span>
                </div>
            </div>
            <div className='flex  my-4'>
                <div className='flex align-items-center flex-column mr-2 my-1'>
                    <i className='block text-lg pi pi-circle'></i>
                    <span className='map-border-line'></span>
                    <i className='block text-lg pi pi-map-marker'></i>
                </div>
                <div>
                    <p className='mb-3 ml-2 font-semibold text-lg'>Gulberg green</p>
                    <p className='mb-0 ml-2 font-semibold text-lg'>G10 Markaz</p>
                </div>
            </div>
            <div className='grid lg:justify-content-between'>
                <div className='col-3 lg:col-2 xl:col-1 flex flex-column align-items-start mx-2'>
                    <p className='mb-1'>Distance</p>
                    <h6 className='my-0 font-semibold'>26.6KM</h6>
                </div>
                <div className='col-3 lg:col-2 xl:col-1 flex flex-column align-items-start mx-2'>
                    <p className='mb-1'>Match</p>
                    <h6 className='my-0 font-semibold'>0</h6>
                </div>
                <div className='col-3 lg:col-2 xl:col-1 flex flex-column align-items-start mx-2'>
                    <p className='mb-1'>Requests</p>
                    <h6 className='my-0 font-semibold'>0</h6>
                </div>
                <div className='col-3 lg:col-2 xl:col-1 flex flex-column align-items-start mx-2'>
                    <p className='mb-1'>Duration</p>
                    <h6 className='my-0 font-semibold'>0h:28m</h6>
                </div>
                <div className='col-3 lg:col-2 xl:col-1 flex flex-column align-items-start mx-2'>
                    <p className='mb-1'>Seat</p>
                    <h6 className='my-0 font-semibold'>1</h6>
                </div>


            </div>
            <Button className='block mx-auto mt-5 delete-btn ' type="button">{btnLabel}</Button>
        </div>
    )
}

export default DetailRideCard